import { memo } from 'react'
import { StyleSheet, View } from 'react-native'
import {
    useCustomersSearchQuery,
    useSetCustomersSearchQuery,
} from '@/stores/customers-search-store'
import { DebouncedSearchbar } from '@/ui/DebouncedSearchbar'

export const CustomersListHeader = memo(function CustomersListHeader() {
    const searchQuery = useCustomersSearchQuery()
    const setSearchQuery = useSetCustomersSearchQuery()

    return (
        <View style={styles.container}>
            <DebouncedSearchbar
                placeholder="Search customers..."
                value={searchQuery}
                onChangeText={setSearchQuery}
            />
        </View>
    )
})

const styles = StyleSheet.create({
    container: {
        paddingTop: 16,
        paddingBottom: 8,
    },
})
